import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=1a53eb9c&scoped=true"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"
import style0 from "./TextAreaField.vue?vue&type=style&index=0&id=1a53eb9c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a53eb9c",
  null
  
)

export default component.exports